import styled from '@emotion/styled'

export const FieldLabel = styled.label`
	display: block;
	font-size: 100%;
	font-weight: bold;
	color: ${({ theme }) => theme.colors.buttonText};
	margin: 1em 0 0px;
`
